module.exports = __webpack_public_path__ + "static/media/staffimg4.132c841e.png";